// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1YjQs","rightAdornment":"Header_rightAdornment__3vrNH"};